import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';

@Component({
	standalone: true,
	selector: 'app-footer',
	imports: [DatePipe],
	template: `<div class="layout-footer">&copy; {{ currentDate | date: 'y' }} PCMC Copyright</div>`
})
export class AppFooter {
	currentDate = new Date();
}
